/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetOfferDetailsByOfferRequestIdAndOfferIdAsExcel$Params {
  offerRequestId: string;
  offerId: string;
}

export function getOfferDetailsByOfferRequestIdAndOfferIdAsExcel(http: HttpClient, rootUrl: string, params: GetOfferDetailsByOfferRequestIdAndOfferIdAsExcel$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, getOfferDetailsByOfferRequestIdAndOfferIdAsExcel.PATH, 'get');
  if (params) {
    rb.path('offerRequestId', params.offerRequestId, {});
    rb.path('offerId', params.offerId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

getOfferDetailsByOfferRequestIdAndOfferIdAsExcel.PATH = '/offers/requests/{offerRequestId}/offers/{offerId}/excel';
